<template>
  <div class="theme-product">
    <div
      class="pro-container"
      v-show="productData.hotRecommendedList.length > 0"
    >
      <div class="pro-wrapper">
        <div class="pro-bar clearfix">
          <span class="pro-title">热门推荐</span>
        </div>
        <ul class="pro-hot-product clearfix">
          <li
            v-for="(item, index) in productData.hotRecommendedList"
            :key="index"
          >
            <router-link
              :to="{
                name: item.type === 1 ? 'MajorDetail' : 'CourseDetail',
                params: { id: item.productId },
              }"
            >
              <div class="hot-product-img">
                <div class="can-integral" v-if="item.isIntegral"></div>
                <div class="can-live" v-if="item.hasLive"></div>
                <img v-lazy="concatImageUrl(item.image, 260, 130)" />
              </div>
              <h3 class="hot-product-title">{{ item.name }}</h3>
              <span class="hot-product-type">【{{ item.specialName }}】</span>
              <span class="hot-product-price">
                <span
                  v-show="
                    formatPrice(item.reducedPrice, item.marketPrice)[0] !== '-1'
                  "
                >
                  ￥{{
                    formatPrice(item.reducedPrice, item.marketPrice)[0]
                  }}</span
                >
                <s
                  v-show="
                    formatPrice(item.reducedPrice, item.marketPrice)[1] !== '-1'
                  "
                  style="
                    margin-left: 8px;
                    color: #808080;
                    font-weight: normal;
                    font-size: 12px;
                  "
                  >￥{{
                    formatPrice(item.reducedPrice, item.marketPrice)[1]
                  }}</s
                >
              </span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <!-- 最新上线 -->
    <div class="pro-container" v-show="productData.latestOnlineList.length > 0">
      <div class="pro-wrapper">
        <div class="pro-bar clearfix">
          <span class="pro-title">最新上线</span>
        </div>
        <theme-product-swiper
          :data="productData.latestOnlineList"
        ></theme-product-swiper>
      </div>
    </div>

    <!-- 最新文章 -->
    <div
      class="pro-container"
      v-show="productData.newsSectionList.articles.length > 0"
    >
      <div class="pro-wrapper">
        <div class="pro-bar clearfix">
          <span class="pro-title">新闻公告</span>
          <router-link
            class="pro-more"
            :to="{
              name: 'NewsList',
              params: { id: productData.newsSectionList.categoryId },
            }"
            v-show="productData.newsSectionList.categoryId > 0"
            >more</router-link
          >
        </div>

        <div class="pro-message clearfix">
          <div class="pro-message-left">
            <div class="pro-message-banner">
              <img
                v-if="productData.newsSectionList.image"
                :src="
                  concatImageUrl(productData.newsSectionList.image, 560, 320)
                "
              />
              <img v-else src="../../assets/images/theme/news-default.png" />
            </div>
          </div>
          <div class="pro-message-right">
            <ul class="pro-message-list">
              <li
                v-for="(item, index) in productData.newsSectionList.articles"
                :key="index"
              >
                <router-link
                  :to="{ name: 'NewsDetail', params: { id: item.id } }"
                >
                  <span>•</span>
                  {{ item.title }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 产品列表 -->
    <div
      class="pro-container"
      v-for="(item, index) in productData.productCategoryList"
      :key="index"
    >
      <div class="pro-wrapper">
        <div class="pro-bar clearfix">
          <span class="pro-title">{{ item.dmTypeName }}</span>
          <router-link
            class="pro-more"
            :to="{ name: 'ProductList', query: { c: item.dmTypeId } }"
            >more</router-link
          >
        </div>
        <ul class="pro-product-label clearfix">
          <li v-for="(label, labelIndex) in item.dmLables" :key="labelIndex">
            <span>{{ label.lableName }}</span>
            <ul>
              <li
                v-for="(major, majorIndex) in label.majorList"
                :key="majorIndex"
              >
                <a
                  href="javascript:;"
                  :title="major.MajorName"
                  @click="getProductList(item, major.MajorID)"
                  >{{ major.MajorName }}</a
                >
              </li>
            </ul>
          </li>
        </ul>

        <div class="pro-product-body clearfix">
          <div :class="index % 2 == 0 ? 'float-left' : 'float-right'">
            <div class="pro-product-banner">
              <router-link
                :to="{ name: 'ProductList', query: { c: item.dmTypeId } }"
              >
                <img
                  v-if="siteConfig.agencyId == 0 || !item.image"
                  :src="getBannerUrl(index)"/>
                <img v-else :src="concatImageUrl(item.image, 260, 460)"
              /></router-link>
            </div>
          </div>
          <div :class="index % 2 != 0 ? 'float-left' : 'float-right'">
            <ul class="pro-product-list clearfix">
              <li
                v-for="(product, productIndex) in item.productList"
                :key="productIndex"
              >
                <router-link
                  :to="{
                    name: product.type === 1 ? 'MajorDetail' : 'CourseDetail',
                    params: { id: product.productId },
                  }"
                >
                  <div class="can-integral" v-if="product.isIntegral"></div>
                  <div class="hot-product-img">
                    <div class="can-live" v-if="product.hasLive"></div>
                    <img v-lazy="concatImageUrl(product.image, 260, 130)" />
                  </div>
                  <h3 class="hot-product-title">{{ product.name }}</h3>
                  <span class="hot-product-type"
                    >【{{ product.specialName }}】</span
                  >
                  <span class="hot-product-price">
                    <span
                      v-show="
                        formatPrice(
                          product.reducedPrice,
                          product.marketPrice
                        )[0] !== '-1'
                      "
                      >￥{{
                        formatPrice(
                          product.reducedPrice,
                          product.marketPrice
                        )[0]
                      }}</span
                    >
                    <s
                      v-show="
                        formatPrice(
                          product.reducedPrice,
                          product.marketPrice
                        )[1] !== '-1'
                      "
                      style="
                        margin-left: 8px;
                        color: #808080;
                        font-weight: normal;
                        font-size: 12px;
                      "
                      >￥{{
                        formatPrice(
                          product.reducedPrice,
                          product.marketPrice
                        )[1]
                      }}</s
                    >
                  </span>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <friend-link v-show="siteConfig.agencyId != 0"></friend-link>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { home } from "../../request";
import ThemeProductSwiper from "./ThemeProductSwiper";
import FriendLink from "./FriendLink";
export default {
  mixins: [siteMixin],
  data() {
    return {
      hotProductList: [],
      productData: {
        hotRecommendedList: [],
        latestOnlineList: [],
        newsSectionList: {
          image: "",
          categoryId: 0,
          articles: [],
        },
        productCategoryList: [],
      },
    };
  },
  mounted() {
    this.getProductData();
  },
  methods: {
    getProductData() {
      home.getThemeData(this.siteConfig.agencyId).then((result) => {
        if (result.status === 1) {
          if (result.data.product) {
            this.productData = result.data.product;
          } else {
            this.$Message.error("数据异常1");
          }
        }
      });
    },
    getProductList(item, m) {
      //console.log(item, m);
      home.getProductList(this.siteConfig.agencyId, m).then((res) => {
        //console.log(res);
        if (res.status === 1) {
          item.productList = res.data;
        }
      });
    },
    getBannerUrl(index) {
      let num = (index % 3) + 1;
      return `/img/pro-0${num}.png`;
    },
  },
  components: {
    ThemeProductSwiper,
    FriendLink,
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var";
.pro-container {
  width: 100%;
  .theme-product > &:nth-child(2n) {
    background-color: #fff5e7;
  }
  .theme-product > &:nth-child(2n + 1) {
    background-color: #fff;
  }
  .can-integral {
    .can-integral();
    left: 0;
    top: 0;
  }
  .can-live {
    .can-live();
    left: -1px;
    bottom: 0;
  }
}
.pro-wrapper {
  width: 1200px;
  margin: 0 auto;
  .pro-bar {
    padding: 20px 30px;
    border-bottom: 1px solid #ccc;

    .pro-title {
      font-size: 2.6rem;
      font-weight: bold;
      letter-spacing: 0.2rem;
    }

    .pro-more {
      font-size: 1.8rem;
      float: right;
      margin-top: 15px;
    }
  }
}

.pro-hot-product {
  li {
    float: left;
    width: 260px;
    height: 200px;
    margin: 30px 20px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 1px 1px 5px #ccc;
    background-color: #fff;
    position: relative;

    &:hover {
      background-color: #ccc;

      img {
        opacity: 0.8;
      }
    }

    .hot-product-img {
      position: relative;
      width: 100%;
      height: 130px;
      overflow: hidden;

      img {
        width: 100%;
      }
    }

    .hot-product-title {
      padding: 0 5px;
      height: 40px;
      line-height: 40px;
      color: #333;
      .ellipsis();
    }

    .hot-product-type {
      color: #999;
    }

    .hot-product-price {
      float: right;
      color: #ff6600;
      margin-right: 10px;
      margin-top: 2px;
      font-weight: bold;
    }
  }
}

.pro-message {
  padding-bottom: 40px;

  .pro-message-left {
    float: left;
    width: 580px;

    .pro-message-banner {
      width: 560px;
      height: 320px;
      margin: 25px 10px 10px 10px;
      border-radius: 10px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .pro-message-right {
    float: left;
    width: 580px;
    margin-left: 40px;

    .pro-message-list {
      width: 560px;
      margin: 0 auto;
      padding-top: 30px;

      li {
        a {
          display: block;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          height: 35px;
          line-height: 35px;
          font-size: 1.6rem;

          span {
            font-size: 3.2rem;
            vertical-align: middle;
            margin-right: 10px;
            color: #666;
          }

          &:hover {
            color: #ff6600;

            span {
              color: #ff6600;
            }
          }
        }

        p {
          padding-left: 30px;
          padding-bottom: 15px;
          text-indent: 2em;
          color: #999;
        }
      }
    }
  }
}

.pro-product-label {
  padding: 10px;

  & > li {
    float: left;
    position: relative;
    padding: 5px 0;
    width: 100px;
    margin: 0 5px;
    text-align: center;
    border-bottom: 3px solid transparent;

    & > span {
      display: block;
      font-size: 1.6rem;
      font-weight: bold;
      max-width: 100px;
      height: 21px;
      overflow: hidden;
    }

    & > ul {
      display: none;
      position: absolute;
      top: 34px;
      left: -65px;
      width: 230px;
      box-shadow: 1px 1px 5px #ccc;
      border-radius: 10px;
      background-color: #fff;
      padding: 15px 0;
      z-index: 10;

      li {
        height: 35px;
        line-height: 35px;
        text-align: center;
        font-size: 1.4rem;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0 8px;
        &:hover {
          background-color: #f5f5f5;

          a {
            color: #ff6600;
          }
        }
      }
    }

    &:hover {
      border-color: #ff6600;

      & > ul {
        display: block;
      }
    }
  }
}

.pro-product-body {
  padding-top: 10px;
  .float-left {
    float: left;
  }

  .float-right {
    float: right;
  }
  .pro-product-banner {
    width: 260px;
    height: 460px;
    margin: 0 20px;
    border-radius: 10px;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .pro-product-list {
    width: 900px;
    li {
      float: left;
      width: 260px;
      height: 210px;
      margin: 0px 20px 40px 20px;
      border-radius: 10px;
      overflow: hidden;
      box-shadow: 1px 1px 5px #ccc;
      background-color: #fff;
      position: relative;

      &:hover {
        background-color: #ccc;

        img {
          opacity: 0.8;
        }
      }

      .hot-product-img {
        position: relative;
        width: 100%;
        height: 130px;
        overflow: hidden;

        img {
          width: 100%;
        }
      }

      .hot-product-title {
        padding: 0 5px;
        height: 50px;
        line-height: 50px;
        color: #333;
        .ellipsis();
      }

      .hot-product-type {
        color: #999;
      }

      .hot-product-price {
        float: right;
        color: #ff6600;
        margin-right: 10px;
        margin-top: 2px;
        font-weight: bold;
      }
    }
  }
}
</style>
